export class UserReferral {

  public activeCredits: string;
  public activeReferrals: number;
  public appliedCredits: string;
  public appliedReferrals: number;
  public pendingCredits: string;
  public pendingReferrals: number;
  public creditsPerReferral: string;
  public leaderBoard: UserReferralLeaderBoard[];
  public referralHash: string;

  constructor() {}

}

export class UserReferralLeaderBoard {

  public index: number;
  public name: string;
  public id: number;
  public allReferrals: string;
  public appliedCredits: string;
  public appliedReferralsCount: string;
  public pendingCredits: string;
  public pendingReferralsCount: string;
  public activeCredits: string;
  public activeReferralsCount: string;

  constructor() {}

}
